import { takeLatest, call, put } from "redux-saga/effects";
import {
  addNewCompanyAction,
  addUserAction,
  editCompanyAction,
  editSettingsAction,
  getAllCompaniesAction,
  getCompanyDetailsAction,
  getEachCompanyDetailsAction,
  getEachUserDetailsAction,
  search,
  updateCompanyPermissionAction,
  userManagementSearch,
} from "../api/company-action";
import {
  getAllCompany,
  getCompany,
  getEachCompany,
  getEachUser,
  getSearch,
  setCompanyDetailsLoading,
  setIsCompanyLoading,
  setisSearchLoading,
} from "../redux/app/company/company-slice";
import { toast } from "react-toastify";

export function* getCompanySaga(action) {
  try {
    const companyDetails = yield call(getCompanyDetailsAction, action.payload);
    yield put(getCompany({ companyDetails }));
  } catch (error) {}
}

export function* getEachCompanyDetailSaga(action) {
  try {
    yield put(
      setCompanyDetailsLoading({
        companyDetailsLoading: true,
      })
    );
    const companyDetails = yield call(
      getEachCompanyDetailsAction,
      action.payload
    );

    yield put(getEachCompany({ companyDetails }));
    yield put(
      setCompanyDetailsLoading({
        companyDetailsLoading: false,
      })
    );
  } catch (error) {}
}

export function* getEachUserDetailsSaga(action) {
  try {
    const userDetails = yield call(getEachUserDetailsAction, action.payload);
    yield put(getEachUser({ userDetails }));
  } catch (error) {}
}

export function* searchSaga(action) {
  try {
    yield put(
      setisSearchLoading({
        isSearchLoading: true,
      })
    );
    // const response = yield call(search, action.payload);

    const response = yield call(userManagementSearch, action.payload);
    //
    yield put(
      getSearch({
        search: response,
      })
    );
    yield put(
      setisSearchLoading({
        isSearchLoading: false,
      })
    );
  } catch (error) {}
}

// add user saga
export function* addUserSaga(action) {
  try {
    toast.loading("Creating user...");
    const response = yield call(addUserAction, action.payload);

    if (response) {
      toast.dismiss();
      yield put({
        type: "GET_COMPANY",
        payload: { token: action.payload.token },
      });
      toast.success("User Added Successfully");
    }
  } catch (error) {
    toast.dismiss();

    if (error.response.data.message.includes("duplicate key error")) {
      toast.error("User already exists", {
        autoClose: 5000,
      });
    }
  }
}

export function* addCompanySaga(action) {
  try {
    toast.loading("Creating company...");
    const response = yield call(addNewCompanyAction, action.payload);

    if (response) {
      toast.dismiss();
      yield put({
        type: "GET_COMPANY",
        payload: { token: action.payload.token },
      });
      toast.success("New Company Created Successfully");
    }
  } catch (err) {}
}

export function* editCompanySaga(action) {
  try {
    const response = yield call(editCompanyAction, action.payload);

    if (response.status === 200) {
      toast.success("Company Updated Successfully");
      yield put({
        type: "GET_EACH_COMPANY",
        payload: { id: action.payload.companyId, token: action.payload.token },
      });
    }
  } catch (err) {}
}

export function* editCompanyForCancelBookingSaga(action) {
  try {
    const response = yield call(editCompanyAction, action.payload);

    if (response.status === 200) {
      yield put({
        type: "GET_EACH_COMPANY",
        payload: { id: action.payload.companyId, token: action.payload.token },
      });
    }
  } catch (err) {}
}

export function* editCompanyForbookingSaga(action) {
  try {
    const response = yield call(editCompanyAction, action.payload);

    if (response.status === 200) {
      yield put({
        type: "GET_EACH_COMPANY",
        payload: { id: action.payload.companyId, token: action.payload.token },
      });
    }
  } catch (err) {}
}

export function* getAllComapnySaga(actions) {
  const response = yield call(getAllCompaniesAction, actions.payload);

  yield put(getAllCompany({ allCompany: response }));
}

export function* editCompanySettingsSaga(actions) {
  const response = yield call(editSettingsAction, actions.payload);

  if (response.status === 200) {
    toast.success("Company Updated Successfully");
    yield put({
      type: "GET_EACH_COMPANY",
      payload: { id: actions.payload.id, token: actions.payload.token },
    });
  }
}

export function* updateCompanyPermissionSaga(actions) {
  try {
    toast.loading("Updating Company permission...");
    const response = yield call(updateCompanyPermissionAction, actions.payload);

    if (response.status === 200) {
      toast.success("Company Updated Successfully");
      yield put({
        type: "GET_EACH_COMPANY",
        payload: { id: actions.payload.id, token: actions.payload.token },
      });
    }
  } catch (error) {
    toast.dismiss();
    toast.error("Something went wrong");
  }
}

export function* watchCompanyAsync() {
  yield takeLatest("GET_COMPANY", getCompanySaga);
  yield takeLatest("SEARCH", searchSaga);
  yield takeLatest("ADD_USER", addUserSaga);
  yield takeLatest("ADD_COMPANY", addCompanySaga);
  yield takeLatest("GET_EACH_COMPANY", getEachCompanyDetailSaga);
  yield takeLatest("GET_EACH_USER", getEachUserDetailsSaga);
  yield takeLatest("EDIT_COMPANY", editCompanySaga);
  yield takeLatest(
    "EDIT_COMPANY_FOR_CANCEL_BOOKING",
    editCompanyForCancelBookingSaga
  );
  yield takeLatest("EDIT_COMPANY_FOR_BOOKING", editCompanyForbookingSaga);
  yield takeLatest("GET_ALL_COMPANY", getAllComapnySaga);
  yield takeLatest("EDIT_COMPANY_SETTINGS", editCompanySettingsSaga);
  yield takeLatest("UPDATE_COMPANY_PERMISSION", updateCompanyPermissionSaga);
}

// return (
//   <div>
//     <TreeItem
//       onClick={() => {
//         setisSelect(true);
//         setIsSelectComapnyDetail(true);
//         dispatch({
//           type: "GET_EACH_COMPANY",
//           payload: { token, id: companyDetails._id },
//         });
//         setcompanyCityPrice(company?.cityprice);
//       }}
//       nodeId={companyDetails?._id}
//       label={
//         companyDetails.companyName
//           ? companyDetails.companyName
//           : "loading..."
//       }
//       sx={{ fontWeight: "bold", width: "100%" }}
//       icon={
//         <FontAwesomeIcon
//           icon={faBuilding}
//           className="text-primary"
//         />
//       }
//       className="space-y-1 text-primary "
//     >
//       {companyDetails?.users?.map((singleUser) => {
//         return (
//           <>
//             <TreeItem
//               onClick={() => {
//                 setIsSelectComapnyDetail(false);
//                 dispatch({
//                   type: "GET_EACH_USER",
//                   payload: {
//                     token,
//                     userid: singleUser?._id,
//                   },
//                 });
//                 // setuserCityPrice(singleUser?.cityprice);
//               }}
//               nodeId={singleUser?._id}
//               className="space-y-3 font-extrabold text-gray-700"
//               label={singleUser.userName}
//               icon={
//                 <UserIcon className="text-gray-500" />
//               }
//             />
//           </>
//         );
//       })}
//       {companyDetails?.company?.map((singleCompany) => {
//         return (
//           <>
//             <TreeItem
//               onClick={() => {
//                 setIsSelectComapnyDetail(true);
//                 dispatch({
//                   type: "GET_EACH_COMPANY",
//                   payload: {
//                     token,
//                     id: singleCompany._id,
//                   },
//                 });
//                 // setcompanyCityPrice(singleCompany?.cityprice);
//               }}
//               nodeId={singleCompany._id}
//               className="space-y-1 text-yellow-900 "
//               icon={
//                 <FontAwesomeIcon
//                   icon={faBuildingUser}
//                   className="w-5 text-yellow-900 "
//                 />
//               }
//               label={singleCompany.companyName}
//             >
//               {singleCompany?.users?.map((user) => (
//                 <>
//                   <TreeItem
//                     onClick={() => {
//                       setIsSelectComapnyDetail(false);
//                       dispatch({
//                         type: "GET_EACH_USER",
//                         payload: {
//                           token,
//                           userid: user._id,
//                         },
//                       });
//                       setuserCityPrice(user?.cityprice);
//                     }}
//                     nodeId={user._id}
//                     className="space-y-3 font-extrabold text-gray-700"
//                     label={user.userName}
//                     icon={
//                       <UserIcon className="text-gray-500" />
//                     }
//                   />
//                 </>
//               ))}
//               {singleCompany?.company?.map(
//                 (singleSubcompany) => (
//                   <>
//                     <TreeItem
//                       onClick={() => {
//                         setIsSelectComapnyDetail(true);
//                         dispatch({
//                           type: "GET_EACH_COMPANY",
//                           payload: {
//                             token,
//                             id: singleSubcompany._id,
//                           },
//                         });
//                         setcompanyCityPrice(
//                           singleSubcompany?.cityprice
//                         );
//                       }}
//                       nodeId={singleSubcompany._id}
//                       label={
//                         singleSubcompany.companyName
//                       }
//                       className="space-y-1 font-extrabold text-yellow-700"
//                       icon={
//                         <OfficeBuildingIcon className="text-yellow-900" />
//                       }
//                     >
//                       {singleSubcompany?.users?.map(
//                         (user) => (
//                           <>
//                             <TreeItem
//                               onClick={() => {
//                                 setIsSelectComapnyDetail(
//                                   false
//                                 );
//                                 dispatch({
//                                   type: "GET_EACH_USER",
//                                   payload: {
//                                     token,
//                                     userid: user?._id,
//                                   },
//                                 });
//                                 setuserCityPrice(
//                                   user?.cityprice
//                                 );
//                               }}
//                               nodeId={user._id}
//                               className="space-y-3 font-extrabold text-gray-700"
//                               label={user.userName}
//                               icon={
//                                 <UserIcon className="text-gray-500" />
//                               }
//                             />
//                           </>
//                         )
//                       )}
//                     </TreeItem>
//                   </>
//                 )
//               )}
//             </TreeItem>
//           </>
//         );
//       })}
//     </TreeItem>
//   </div>
// );
